import React from 'react'
import { Link } from 'react-router-dom'
import { openConsentSettings } from '../lib/analytics'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800" data-testid="site-footer">
      <div className="container mx-auto px-4 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Brand + provider info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-3">EduMisia</h3>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Online platforma na priebežnú prípravu na Testovanie 9 s testami, výsledkami a vysvetleniami na jednom mieste.
            </p>
            <p className="text-sm text-gray-400 mb-4">
              © {currentYear} EduMisia. Všetky práva vyhradené.
            </p>

            {/* Provider Identification (legal) */}
            <div className="text-xs text-gray-500 space-y-1 pt-4 border-t border-gray-800">
              <h4 className="text-gray-400 font-medium mb-2">Údaje o poskytovateľovi</h4>
              <p>Vedený v Živnostenskom registri SR</p>
              <p>Číslo živnostenského registra: 430-58126</p>
              <p className="font-medium text-gray-400">Mgr. Vladislava Pajerová</p>
              <p>IČO: 51360454</p>
              <p>Miesto podnikania: 97409 Banská Bystrica, Lipová 6459/4</p>
            </div>
          </div>

          {/* Užitočné odkazy */}
          <nav aria-label="Užitočné odkazy">
            <h3 className="text-white font-semibold text-lg mb-4">Užitočné odkazy</h3>
            <ul className="space-y-3 text-sm" data-testid="footer-useful-links">
              <li>
                <Link to="/pricing" className="block py-1 hover:text-white transition">
                  Cenník
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="block py-1 hover:text-white transition">
                  Časté otázky
                </Link>
              </li>
              <li>
                <Link to="/contact" className="block py-1 hover:text-white transition">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="block py-1 hover:text-white transition">
                  Podmienky používania
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="block py-1 hover:text-white transition">
                  Ochrana osobných údajov
                </Link>
              </li>
            </ul>
          </nav>

          {/* Support + purchase notice */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Podpora</h3>
            <a
              href="mailto:podpora@edumisia.sk"
              className="inline-block text-sm text-blue-400 hover:text-blue-300 transition mb-6"
              data-testid="footer-support-email"
            >
              podpora@edumisia.sk
            </a>

            <h4 className="text-white font-medium text-sm mb-2">Nákup balíčka</h4>
            <p
              className="text-xs text-gray-400 leading-relaxed"
              data-testid="footer-purchase-notice"
            >
              Balíček môže zakúpiť iba osoba staršia ako 18 rokov, alebo rodič či iný zákonný zástupca maloletého používateľa.
            </p>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-gray-950 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-gray-500 text-center md:text-left">
            <p data-testid="footer-disclaimer">
              EduMisia je vzdelávacia platforma na prípravu. Nie je oficiálnym testom Testovanie 9.
            </p>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
              <Link to="/privacy-policy" className="hover:text-gray-400 transition">
                Súkromie
              </Link>
              <Link to="/terms-of-use" className="hover:text-gray-400 transition">
                Podmienky
              </Link>
              <Link to="/contact" className="hover:text-gray-400 transition">
                Kontakt
              </Link>
              <button
                type="button"
                onClick={openConsentSettings}
                className="hover:text-gray-400 transition underline-offset-2 hover:underline"
                data-testid="footer-cookie-settings"
              >
                Nastavenia cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
